<template>
  <div class="comContent">
    <div class="expand-form">
      <searchForm v-model="searchData" @search="onSearch" :formItems="searchLabelList" @reset="resetForm">
        <div slot="right">
          <el-button size="small" type="primary" @click="checkDetails({}, 'create')">新建</el-button>
        </div>
      </searchForm>
    </div>

    <myTable :index="index" :selection="false" :page="page" :showpage="true" :operation="false" v-loading="loading"
      :table-data="tableData" :table-option.sync="tableOption" @page-change="getList" :expand="false">
      <template slot="status" slot-scope="scope">
        {{ scope.row.status | filtersStatus }}
      </template>

      <template slot="activeTime" slot-scope="scope">
        {{ scope.row.startTime }}
        -
        {{ scope.row.endTime }}
      </template>
      <template slot="operation" slot-scope="scope">
        <div style="margin: 0 0px">
          <el-link type="primary" :underline="false" @click="checkDetails(scope.row, 'detail')"
            style="margin-right: 10px">
            详情
          </el-link>
          <el-link type="primary" :underline="false" @click="checkDetails(scope.row, 'goods')" style="margin-right: 10px">
            补贴商品
          </el-link>
          <el-link type="primary" :underline="false" @click="updateStatus(scope.row, 2)" style="margin-right: 10px"
            v-if="scope.row.status == '1' || scope.row.status == '3'">
            停止补贴
          </el-link>
          <el-link type="primary" :underline="false" @click="checkDetails(scope.row, 'edit')" style="margin-right: 10px"
            v-if="scope.row.status == 0">
            编辑
          </el-link>
          <el-link type="primary" :underline="false" @click="deleteActive(scope.row, 'detel')"
            v-if="scope.row.status == 0" style="margin-right: 10px">
            删除
          </el-link>
        </div>
      </template>
    </myTable>
  </div>
</template>
<script>
const activeOptions = [
  {
    name: "待开始",
    id: 1,
  },
  {
    name: "进行中",
    id: 3,
  },
  {
    name: "已结束",
    id: 4,
  },
  {
    name: "已停止",
    id: 2,
  },
  {
    name: "草稿中",
    id: 0,
  },
];
import searchForm from "./component/searchForm.vue";
import myTable from "@/components/myTable";
// import { orderSalePage } from "@/api/businessManage";
import {
  subsidyList,
  subsidyStartOrStop,
  subsidyDelete,
} from "@/api/platSubsidyManage";
// 平台补贴管理
export default {
  components: { searchForm, myTable },
  props: {},
  data() {
    return {
      expanded: false,
      isExpanded: false,
      loading: false,
      operation: true,
      selection: true,
      index: false,
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      tableData: [],
      tableOption: [
        { label: "补贴名称", prop: "name" },
        { label: "补贴时间", prop: "activeTime", slot: true, width: 330 },
        { label: "已补贴金额", prop: "activitySubsidyMoney", type: "money" },
        { label: "参加店铺总数", prop: "storeSum" },
        { label: "参加SKU总数", prop: "skuSum" },
        { label: "补贴状态", prop: "status", slot: true },
        { label: "更新人", prop: "updateBy" },
        { label: "更新时间", prop: "updateTime" },
        { label: "操作", prop: "operation", slot: true },
      ],
      searchData: this.searchDataInit(),
      expandedList: [],
      searchLabelList: [
        {
          name: "搜索补贴名称",
          fieldName: "subsidyName",
          type: "input",
        },
        {
          fieldName: "subsidyTime",
          startName: "补贴开始时间",
          endName: "补贴结束时间",
          type: "daterange",
          width: 260,
        },
        {
          name: "筛选补贴状态",
          width: 150,
          fieldName: "status",
          type: "select",
          select: activeOptions,
        },
      ],
    };
  },
  filters: {
    filtersStatus(e) {
      for (let i = 0; i < activeOptions.length; i++) {
        if (e == activeOptions[i].id) {
          return activeOptions[i].name;
        }
      }
    },
  },
  created() { this.getList(); },
  mounted() {

  },
  methods: {
    onSearch() {
      this.page.current = 1;
      this.getList();
    },
    resetForm() {
      this.page.current = 1;
      this.searchData = this.searchDataInit();
      this.getList();
    },
    searchDataInit() {
      return {
        subsidyName: '', // 补贴活动名
        subsidyTime: [], // 活动时间
        status: ''  // 活动状态
      }
    },
    getList() {
      const { subsidyTime, ...form } = this.searchData;
      const { current, size } = this.page;
      const params = {
        ...form,
        current,
        size
      };
      if (subsidyTime && subsidyTime.length) {
        params.strTime = subsidyTime[0];
        params.endTime = subsidyTime[1];
      }
      this.loading = true
      subsidyList(params).then((res) => {
        this.tableData = res.records || [];
        this.page.total = res.total || 0;
      }).finally(() => {
        this.loading = false
      })
    },
    updateStatus(row) {
      this.$confirm(
        `活动停止后将不能重新开始，是否确认停止【${row.name}】？`,
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          title: `停止活动`,
        }
      )
        .then(({ value }) => {
          subsidyStartOrStop(row.id).then((res) => {
            this.$message.success("操作成功！");
            this.getList();
          });
        })
        .catch((err) => {
          console.log("取消操作");
        });
    },
    deleteActive(row) {
      this.$confirm(`确认删除活动【${row.name}】么？`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        title: "删除活动",
      })
        .then(({ value }) => {
          subsidyDelete(row.id).then((res) => {
            this.$message.success("操作成功！");
            this.getList();
          });
        })
        .catch((err) => {
          console.log("取消操作");
        });
    },
    // 查看详情
    checkDetails(row, type) {
      if (type == "create") {
        this.$router.push({
          path: "./platSubsidyManage-createSubsidy",
          query: {},
        });
      }
      if (type == "detail" || type == "edit") {
        this.$router.push({
          path: "./platSubsidyManage-subsidyDetail",
          query: { id: row.id, type: type },
        });
      }
      if (type == "goods") {
        this.$router.push({
          path: "./platSubsidyManage-subsidyGoodsList",
          query: { id: row.id, type: type },
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep.el-table {
  height: calc(100% - 138px) !important;
}

::v-deep.zt__table {
  height: calc(100% - 118px) !important;
}

::v-deep.zt__table .el-table__body-wrapper {
  height: calc(100% - 78px) !important;
  overflow-y: scroll !important;
}

.expand-form {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .btns-box {
    display: flex;
    align-items: center;
    margin-bottom: 13px;
  }
}
</style>
